import Icon from "@react-native-vector-icons/material-design-icons/static";
import { List, type ListItemProps, Text } from "react-native-paper";
import type { IconType } from "../../icon";
import CustomChip from "../CustomChip";
import { OverlineText } from "../OverlineText";

type Props = {
	rightText?: string;
	icon?: string;
	iconColor?: string;
} & ListItemProps;

const StatListItem = (props: Props) => {
	const { icon, iconColor, title, description, rightText } = props;

	return (
		<List.Item
			style={{
				paddingRight: 0,
			}}
			left={() => (
				<List.Icon
					icon={(iconProps) => (
						<Icon
							{...iconProps}
							name={icon as IconType}
							color={iconColor ?? iconProps.color}
						/>
					)}
				/>
			)}
			title={<OverlineText>{description as string}</OverlineText>}
			description={<Text>{title as string}</Text>}
			right={(p) =>
				rightText ? <CustomChip {...p}>{rightText}</CustomChip> : null
			}
		/>
	);
};

export default StatListItem;
